import React, { useState } from 'react';
import { BreadCrumb } from '../../common/breadcrumb';
import api from '../../../services/axios';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { useJWTAuth } from '../../../services/JWTAuthProvider';
import config from '../../../config';
import { userRole } from '../../../constants/appConst';

export const AddUser = () => {

    const { user } = useJWTAuth();
    //console.log("THE USER ROLE IS:", user.role);
    //const [selectedDropdownItem, setSelectedDropdownItem] = useState('Select Role');
    const [subBtnDisabled, setSubBtnDisabled] = useState(false);
    const [passwordRegexError, setPasswordRegexError] = useState(false);

    const navigate = useNavigate();
    const [showToast] = useState(false);
    const [formValues, setFormValues] = useState({
        name: '',
        id: '',
        password: '',
        confirm: '',
    });
    const [formErrors, setFormErrors] = useState({
        name: '',
        id: '',
        password: '',
        confirm: '',
    });
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState(false);
    const [nameRegexError, setNameRegexError] = useState(false);
    //const [roleSelection, setRoleSelection] = useState('');
    //const [selectedFolders, setSelectedFolders] = useState([]);
    const [folderRoles, setFolderRoles] = useState([]);
    React.useEffect(() => {
        console.log("folderRoles changed:", folderRoles);
    }, [folderRoles]);
    const [isExxonEmployee, setIsExxonEmployee] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    //const [roleRequiredError, setroleRequiredError] = useState(false);
    const [folderRequiredError, setfolderRequiredError] = useState(false);
    const [bulkRole, setBulkRole] = useState(0);
    const [isGlobalAdmin, setIsGlobalAdmin] = useState(false);

    const roleMapping =
    {
        1: "GlobalAdmin",
        2: "BusinessUnitAdmin",
        3: "BusinessUnitUser",
        4: "BusinessUnitUserAdministrator"
    }

    const getRoleLevel = (currentRole) => {
        switch (currentRole) {
            case userRole.GlobalAdmin:
                return 100;
            case userRole.BusinessUnitAdmin:
                return 80;
            case userRole.BusinessUnitUserAdministrator:
                return 50;
            case userRole.BusinessUnitUser:
                return 10;
            default:
                console.warn("Role not matched in getRoleLevel! Raw value:", currentRole);
                return 0;
        }
    };

    //const currentUserLevel = getRoleLevel(user.role);
    // const highestRole = user?.isGlobalAdmin
    //     ? userRole.GlobalAdmin
    //     : Math.min(...(user?.folders ?? []).map(f => f.role));

    //     const getCurrentUserRole = () => {

    //     console.log("Full user object:", user);
    //     console.log("Folders:", user?.folders);

    //     if (user?.isGlobalAdmin) {
    //         console.log("Global Admin");
    //         return userRole.GlobalAdmin;
    //     }

    //     if (!user?.folders?.length) {
    //         console.log("No folders");
    //         return 0;
    //     }

    //     const roles = user.folders.map(f => f.role);

    //     console.log("Folder roles:", roles);

    //     const minRole = Math.min(...roles);

    //     console.log("Computed role:", minRole);

    //     return minRole;
    // };

    const getCurrentFolderRole = (folderId) => {

        if (user?.isGlobalAdmin)
            return userRole.GlobalAdmin;

        // const folder = user?.folders?.find(
        //     x => x.folderIdentifier === folderId
        // );

        const folder = user?.folders?.find(
            x =>
                x.folderIdentifier?.toLowerCase() ===
                folderId?.toLowerCase()
        );

        return folder?.role ?? 0;
    };


    // const getCurrentUserRole = () => {

    //     if (user?.isGlobalAdmin)
    //         return userRole.GlobalAdmin;

    //     if (!user?.folders?.length)
    //         return 0;

    //     return user.folders.reduce(
    //         (highest, folder) => folder.role < highest ? folder.role : highest,
    //         userRole.BusinessUnitUser
    //     );
    // };

    //const currentUserLevel = getRoleLevel(getCurrentUserRole());

    //const currentUserLevel = getRoleLevel(highestRole);

    const roleOptions = [
        { id: 1, label: "GlobalAdmin", minLevelRequired: 100 },
        { id: 2, label: "BusinessUnitAdmin", minLevelRequired: 80 },
        { id: 4, label: "BusinessUnitUserAdministrator", minLevelRequired: 50 },
        { id: 3, label: "BusinessUnitUser", minLevelRequired: 50 }
    ];


    // Filter the options so the user only sees roles at or below their own level
    //const visibleRoles = roleOptions.filter(role => currentUserLevel >= role.minLevelRequired);
    const getVisibleRoles = (folderId) => {

        const role = getCurrentFolderRole(folderId);

        switch (role) {

            case userRole.GlobalAdmin:
                return roleOptions;

            case userRole.BusinessUnitAdmin:
                return roleOptions.filter(r =>
                    [2, 3, 4].includes(r.id));

            case userRole.BusinessUnitUserAdministrator:
                return roleOptions.filter(r =>
                    [3, 4].includes(r.id));

            case userRole.BusinessUnitUser:
                return roleOptions.filter(r =>
                    r.id === 3);

            default:
                return [];
        }
    };

    const getHighestCreatableRoles = () => {

        if (user?.isGlobalAdmin)
            return roleOptions;

        const roles = user.folders.map(f =>
            getVisibleRoles(f.folderIdentifier)
        );

        const merged = roles.flat();

        return merged.filter(
            (value, index, self) =>
                index === self.findIndex(x => x.id === value.id)
        );
    };
    //     console.log({
    // currentUserRole: getCurrentUserRole(),
    // currentUserLevel,
    // visibleRoles,
    // bulkRole
    // });
    console.log("userRole enum", userRole);
    console.log(user.folders);

    const [folderList, setFolderList] = React.useState([]);
    React.useEffect(() => {
        const getData = async () => {
            try {
                const { data } = await api.get("/Folders/getrootfolders?Id=" + user.id);
                if (data.statusCode === 200) {
                    setFolderList(data.result.folders);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        getData();
    }, [user.id]);

    // const handleDropdownItemClick = (number) => {
    //     /*validateForm();*/
    //     setSelectedDropdownItem(roleMapping[number]);
    //     setRoleSelection(number); // Update the selected Role

    //     setroleRequiredError(false);
    //     //setSelectedFolders([]);
    //     setFolderRoles([]);
    // };
    if (!isExxonEmployee) {

    }

    const breadcrumbItems = [
        { label: 'Home Page', url: '/' },
        { label: 'User Management', url: '/UserManagement' },
        { label: 'Add User', url: '' },
    ];

    const validatePassword = (password) => {
        const isLengthValid = password.length >= 8 && password.length <= 16;
        const hasSpecialCharacter = /[!@#$%^&*()_+{}[\]:;<>,.?~\\-]/.test(password);
        const hasCapitalLetter = /[A-Z]/.test(password);
        const hasLowerLetter = /[a-z]/.test(password);
        return isLengthValid && hasSpecialCharacter && hasCapitalLetter && hasLowerLetter;
    };



    const validateForm = () => {
        const errors = {};
        if (!formValues.name) {
            errors.name = '* Name is required';
        }
        if (!formValues.id) {
            errors.id = '* User ID is required';
        }

        if (formValues.name) {
            const regex = /^[a-zA-Z0-9' ]+$/;

            // Check if the entered username matches the pattern
            const isValid = regex.test(formValues.name);
            if (!isValid) {
                setNameRegexError(true);
                setSubBtnDisabled(false);
                return;
            }
        }


        if (!isExxonEmployee) {
            if (!formValues.password) {
                errors.password = '* Password is required';
            }
            if (!formValues.confirm) {
                errors.confirm = '* Confirm Password is required';
            }
            if (formValues.confirm !== formValues.password) {
                errors.confirm = '* Confirm Password should be same as Password';
            }
            if (config.SSODOMAIN.findIndex((e) => formValues.id.toLowerCase().includes(e)) >= 0) {
                errors.id = '* Please use Non Exxon UserID or Email';
            }

        }

        if (isExxonEmployee) {
            if (config.SSODOMAIN.findIndex((e) => formValues.id.toLowerCase().includes(e)) >= 0) {

            }
            else {
                errors.id = '* Please use Exxon UserID';
            }
        }

        if (!isValidUserID(formValues.id)) {
            errors.id = '* Please enter valid UserID';
        }

        setFormErrors(errors);
        return Object.values(errors).every((error) => error === '');
    };

    const handleInputChange = (fieldName, value) => {
        setFormErrors({ ...formErrors, [fieldName]: '' });

        if (fieldName === 'confirm') {
            setPasswordMatchError(false);
        }

        setFormValues({ ...formValues, [fieldName]: value });
    };

    const handleclose = () => {
        navigate('/UserManagement');
    }

    const isValidUserID = (name) => {
        // Regular expression for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // Regular expression for proper name validation
        const nameRegex = /^[a-zA-Z0-9_` ]+$/;

        // Check if the name matches either email or proper name format
        return emailRegex.test(name) || nameRegex.test(name);
    }

    // Example email validation function
    const isValidEmail = (email) => {
        // Add your email validation logic here
        // Return true if the email is valid, false otherwise
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleSubmit = async (e) => {
        setSubBtnDisabled(true)
        e.preventDefault();
        setIsFormSubmitted(true);
        // if (roleSelection === "") {
        //     setroleRequiredError(true);
        //     setSubBtnDisabled(false);
        // }
        var isSSOLogin = '';
        if (validateForm()) {
            var password = ''
            if (isExxonEmployee) {
                password = '';
                isSSOLogin = true;
                formValues.password = '';
                formValues.confirm = '';
            }
            else {
                password = formValues.password;
                if (!validatePassword(password)) {
                    setPasswordRegexError(true);
                    setSubBtnDisabled(false);
                    return;
                }
                isSSOLogin = false;
            }

            if (formValues.id) {
                //const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                //const isValid = emailRegex.test(formValues.id);
                //if (!isValid) {
                //    setEmailRegerError(true);
                //    setSubBtnDisabled(false);
                //    return;
                //}
            }
            if (!isGlobalAdmin && folderRoles.length === 0) {
                setfolderRequiredError(true);
                setSubBtnDisabled(false);
                return;
            }

            // if (roleSelection !== 1 && folderRoles.length === 0) {
            //     setfolderRequiredError(true);
            //     setSubBtnDisabled(false);
            //     return;
            // }
            // if (roleSelection === 1) {
            //     CheckAll();
            // }

            try {
                const { data } = await api.post("/UserCreation/CreateUser", {
                    name: formValues.name,
                    userid: formValues.id,
                    password: password,
                    email: isValidEmail(formValues.id) ? formValues.id : '',
                    //role: roleSelection,
                    isssologin: isSSOLogin,
                    //folders: selectedFolders,
                    folderRoles: folderRoles,
                    isGlobalAdmin: isGlobalAdmin,
                    rowvalue: 0
                });
                if (data.statusCode === 200) {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        text: "User created successfully",
                        confirmButtonText: "Ok",
                        timer: 2000,
                        timerProgressBar: true,
                    }).then(val => {
                        if (val) {
                            navigate('/UserManagement');
                        }
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        setSubBtnDisabled(false)
    };

    // const handleFolderSelection = (folder) => {
    //     setfolderRequiredError(false);
    //     // Add or remove the selected folder from the array
    //     setSelectedFolders((prevSelected) => {
    //         if (prevSelected.includes(folder)) {
    //             return prevSelected.filter((item) => item !== folder);
    //         } else {
    //             return [...prevSelected, folder];
    //         }
    //     });
    // };

    // const handleFolderRoleChange = (folderId, role) => {
    //     setFolderRoles(prev =>
    //         prev.map(item =>
    //             item.folderId === folderId
    //                 ? { ...item, role }
    //                 : item
    //         )
    //     );
    // };

    // const handleFolderRoleChange = (folderId, role) => {

    //     const creatorRole = getCurrentFolderRole(folderId);

    //     // Cannot assign higher privilege than creator
    //     if (role !== 0 && role < creatorRole)
    //         role = creatorRole;

    //     setFolderRoles(prev =>
    //         prev.map(item =>
    //             item.folderId === folderId
    //                 ? { ...item, role }
    //                 : item
    //         )
    //     );
    // };

    const handleFolderRoleChange = async (folderId, role) => {

    // If Global Admin selected from folder dropdown
    if (role === userRole.GlobalAdmin) {

        const result = await Swal.fire({
            title: "Global Admin Access",
            text: "Selecting Global Admin will automatically grant access to all folders/sites. Do you want to continue?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            reverseButtons: true
        });

        if (!result.isConfirmed) {
            return;
        }

        // Same behaviour as Global Admin switch
        setIsGlobalAdmin(true);
        setBulkRole(userRole.GlobalAdmin);

        setFolderRoles(
            folderList.map(folder => ({
                folderId: folder.folderIdentifier,
                role: userRole.GlobalAdmin
            }))
        );

        return;
    }

    // const creatorRole = getCurrentFolderRole(folderId);

    // if (role !== 0 && role < creatorRole)
    //     role = creatorRole;

    setFolderRoles(prev =>
        prev.map(item =>
            item.folderId === folderId
                ? { ...item, role }
                : item
        )
    );
};


    const handleBulkRoleChange = (role) => {
        if (role === 1) {
            setIsGlobalAdmin(true);
        }
        else {
            setIsGlobalAdmin(false);
        }

        setBulkRole(role);

        // setFolderRoles(prev =>
        //     prev.map(folder => {

        //         const creatorRole =
        //             getCurrentFolderRole(folder.folderId);

        //         let assignedRole = role;

        //         if (role !== 0 && role < creatorRole)
        //             assignedRole = creatorRole;

        //         return {
        //             ...folder,
        //             role: assignedRole
        //         };
        //     })
        // );
setFolderRoles(prev =>
    prev.map(folder => ({
        ...folder,
        role
    }))
);
    };

    const handleFolderSelection = (folderIdentifier) => {
        setfolderRequiredError(false);
        console.log("Selected Folder:", folderIdentifier);
        console.log("Bulk Role:", bulkRole);
        //console.log("Current User Role:", getCurrentUserRole());
        console.log(
            "Creator Folder Role:",
            getCurrentFolderRole(folderIdentifier)
        );
        setFolderRoles(prev => {
            const exists = prev.find(x => x.folderId === folderIdentifier);

            if (exists) {
                return prev.filter(x => x.folderId !== folderIdentifier);
            }

            return [
                ...prev,
                {
                    folderId: folderIdentifier,
                    //role: roleSelection
                    //role: bulkRole !== 0 ? bulkRole : 2
                    //role: bulkRole !== 0 ? bulkRole : getCurrentUserRole()
                    //role: bulkRole !== 0 ? bulkRole : getCurrentFolderRole(folderIdentifier)
                    role: bulkRole !== 0 ? bulkRole : 0
                }
            ];
        });
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleNonExxonChange = () => {
        setFormErrors('');
        setIsExxonEmployee(false)
        setPasswordRegexError(false);
        setPasswordMatchError(false);
        setNameRegexError(false);
        //setroleRequiredError(false);
    }

    const handleExxonChange = () => {
        setFormErrors('');
        setIsExxonEmployee(true);
        setPasswordRegexError(false);
        setPasswordMatchError(false);
        setNameRegexError(false);
        //setroleRequiredError(false);
        formValues.password = '';
        formValues.confirm = '';
    }

    const CheckAll = () => {
        if (folderRoles.length === 0 && folderRoles.length < folderList.length) {
            return true;
        }
        else if (folderRoles.length < folderList.length) {
            return true;
        }
        else {
            return false;
        }
    }


    // const handleSelectAllFolders = (e) => {
    //     setfolderRequiredError(false);
    //     if (e.target.checked) {
    //         // Select all folders
    //         setSelectedFolders(folderList.map(li => li.folderIdentifier));
    //     } else {
    //         // Deselect all folders
    //         setSelectedFolders([]);
    //     }
    // };
    // const handleSelectAllFolders = (e) => {
    //     setfolderRequiredError(false);

    //     if (e.target.checked) {
    //         setFolderRoles(
    //             folderList.map(folder => ({
    //                 folderId: folder.folderIdentifier,
    //                 role: roleSelection
    //             }))
    //         );
    //     } else {
    //         setFolderRoles([]);
    //     }
    // };

    const handleSelectAll = () => {

        setfolderRequiredError(false);

        // setFolderRoles(
        //     folderList.map(folder => ({
        //         folderId: folder.folderIdentifier,
        //         //role: bulkRole !== 0 ? bulkRole : roleSelection
        //         //role: bulkRole !== 0 ? bulkRole : 2
        //         role: bulkRole !== 0 ? bulkRole : getCurrentUserRole()
        //     }))
        // );

        setFolderRoles(

            folderList.map(folder => ({

                folderId: folder.folderIdentifier,
                //role: bulkRole !== 0 ? bulkRole : getCurrentFolderRole(folder.folderIdentifier)
                role: bulkRole !== 0 ? bulkRole : 0
            }))
        );
    };

    const handleDeselectAll = () => {

        setFolderRoles([]);

    };

    const getRoleSummary = (role) => {

        switch (role) {
            case 1:

                return (
                    <>
                        <div className="fw-bold text-primary">
                            Global Admin
                        </div>

                        <small>✓ Full System Access</small><br />
                        <small>✓ All Folders</small><br />
                        <small>✓ User Management</small><br />
                        <small>✓ Content Management</small>
                    </>
                );

            case 2:
                return (
                    <>
                        <div className="fw-bold text-primary">
                            BusinessUnitAdmin
                        </div>

                        <small>✓ Content : View</small><br />
                        <small>✓ Content : Add/Edit/Delete</small><br />
                        <small>✓ User : Add/Edit/Delete</small>
                    </>
                );

            case 3:
                return (
                    <>
                        <div className="fw-bold text-primary">
                            BusinessUnitUser
                        </div>

                        <small>✓ Content : View</small><br />
                        <small>✗ Content : Add/Edit/Delete</small><br />
                        <small>✗ User : Add/Edit/Delete</small>
                    </>
                );

            case 4:
                return (
                    <>
                        <div className="fw-bold text-primary">
                            BusinessUnitUserAdministrator
                        </div>

                        <small>✓ Content : View</small><br />
                        <small>✗ Content : Add/Edit/Delete</small><br />
                        <small>✓ User : Add/Edit/Delete</small>
                    </>
                );

            default:
                return (
                    <span className="text-danger">
                        No Access
                    </span>
                );
        }

    };

    const permissionSummary = {
        1: {
            title: "Global Admin",
            permissions: [
                "Full System Access",
                "All Folder Access",
                "User Management",
                "Content Management"
            ]
        },
        2: {
            title: "BusinessUnitAdmin",
            permissions: [
                "Content : View",
                "Content : Add/Edit/Delete",
                "User : Add/Edit/Delete"
            ]
        },
        3: {
            title: "BusinessUnitUser",
            permissions: [
                "Content : View"
            ]
        },
        4: {
            title: "BusinessUnitUserAdministrator",
            permissions: [
                "Content : View",
                "User : Add/Edit/Delete"
            ]
        }
    };

    return (
        <>
            <div className='right-content'>

                <BreadCrumb items={breadcrumbItems}></BreadCrumb>

                <div className='mid-box-wrap'>
                    <h4 className='sub-head'>Add User</h4>
                    <form className='add-form' onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col-md-6 add-user-label'>
                                <div class="mb-2">
                                    <label for="name" class="form-label">Name</label>
                                    <input
                                        type="text"
                                        className={`form-control ${formErrors.name && 'error'}`}
                                        id="name"
                                        placeholder="Enter name"
                                        value={formValues.name}
                                        maxLength="200"
                                        onChange={(e) => {
                                            handleInputChange('name', e.target.value);
                                            setPasswordRegexError(false);
                                            setPasswordMatchError(false);
                                            setNameRegexError(false);
                                        }}
                                    />
                                    {isFormSubmitted && formErrors.name && (
                                        <p className="error-message">{formErrors.name}</p>
                                    )}
                                    {nameRegexError && (
                                        <p className="error-message">* Name should be in valid format</p>
                                    )}
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="exxonMobilEmployee"
                                        id="nonExxon"
                                        checked={!isExxonEmployee}
                                        onClick={() => handleNonExxonChange()}
                                    />
                                    <label className="form-check-label" for="nonExxon">
                                        Non-ExxonMobil Employee
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="exxonMobilEmployee"
                                        id="exxonEmp"
                                        checked={isExxonEmployee}
                                        onClick={() => handleExxonChange()}
                                    />
                                    <label className="form-check-label" for="exxonEmp">
                                        ExxonMobil Employee
                                    </label>
                                </div>


                                <div className={`mb-2 ${isExxonEmployee ? 'add-opacity' : ''}`}>
                                    <label for="password" class="form-label">Password</label>
                                    <div className='input-wrap'>      <input
                                        type={showPassword ? 'text' : 'password'}
                                        className={`form-control ${formErrors.password && 'error'}`}
                                        id="password"
                                        placeholder="Enter Password"
                                        value={formValues.password}
                                        onChange={(e) => {
                                            handleInputChange('password', e.target.value);
                                            setPasswordRegexError(false);
                                            setPasswordMatchError(false);
                                        }}
                                        disabled={isExxonEmployee}
                                    />

                                        <div className={`input-img ${showPassword ? 'show-pass' : 'hide-pass'}`} onClick={togglePasswordVisibility}>
                                        </div></div>

                                    {isFormSubmitted && formErrors.password && (<p className="error-message">{formErrors.password}</p>
                                    )}
                                    {passwordMatchError && (
                                        <p className="error-message">* Confirm Password does not match the Password</p>
                                    )}
                                    {passwordRegexError && <p className='error-message'> * Password must be 8 - 16 characters and have at least one capital letter, small letter and special character(! @#$ % ^ & *?.) </p>}

                                </div>





                            </div>
                            <div className='col-md-6 add-user-label'>

                                <div class="mb-2">
                                    <label for="id" class="form-label">User Id</label>
                                    <input
                                        type="text"
                                        className={`form-control ${formErrors.id && 'error'}`}
                                        id="id"
                                        maxLength="100"
                                        placeholder="Enter User ID"
                                        value={formValues.id}
                                        onChange={(e) => {
                                            handleInputChange('id', e.target.value);
                                            setPasswordRegexError(false);
                                            setPasswordMatchError(false);
                                        }}
                                    />
                                    {isFormSubmitted && formErrors.id && (
                                        <p className="error-message">{formErrors.id}</p>
                                    )}
                                </div>
                                <div className={`mb-2 mt-5 pt-2 ${isExxonEmployee ? 'add-opacity' : ''}`}>
                                    <label for="confirm" class="form-label">Confirm Password</label>
                                    <div className='input-wrap'> <input
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        className={`form-control ${formErrors.confirm && 'error'}`}
                                        id="confirm"
                                        placeholder="Enter Confirm Password"
                                        value={formValues.confirm}
                                        onChange={(e) => handleInputChange('confirm', e.target.value)}
                                        disabled={isExxonEmployee}
                                    />
                                        <div className={`input-img ${showConfirmPassword ? 'show-pass' : 'hide-pass'}`} onClick={toggleConfirmPasswordVisibility}>
                                        </div></div>
                                    {isFormSubmitted && formErrors.confirm && (
                                        <p className="error-message">{formErrors.confirm}</p>
                                    )}
                                </div>
                            </div>
                            <div className='row'>
                                {/* <div class="mb-2">
                                    <label for="dropdownMenuButton1" class="form-label">Role</label>
                                    <div className="dropdown">
                                        <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                            {selectedDropdownItem}
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            {visibleRoles.map((role) => (
                                                <li key={role.id} onClick={() => handleDropdownItemClick(role.id)}>
                                                    <span className="dropdown-item">{role.label}</span>
                                                </li>
                                            ))}
                                        </ul>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            {user.role === userRole.BusinessUnitAdmin ? null :
                                                <li onClick={() => handleDropdownItemClick(1)}><span className="dropdown-item">Global Admin</span></li>
                                            }
                                            <li onClick={() => handleDropdownItemClick(2)}><span className="dropdown-item">Business Unit Admin</span></li>
                                            <li onClick={() => handleDropdownItemClick(3)}><span className="dropdown-item">Business Unit User</span></li>
                                            <li onClick={() => handleDropdownItemClick(4)}><span className="dropdown-item">Business Unit User Administrator</span></li>

                                        </ul>
                                    </div>
                                    {isFormSubmitted}
                                    {roleRequiredError && (
                                        <p className="error-message">* Please select at least one role</p>
                                    )}
                                </div> */}

                                <div className="mb-2">
                                    <label class="form-label">Select Folder</label>
                                    <div className='select-folder'>
                                        <div className='folder-check-wrap'>
                                            <div className="d-flex justify-content-between align-items-center pb-3 mb-3">

                                                {/* Left Side */}
                                                <div className="d-flex align-items-center">

                                                    {/* Global Admin */}
                                                    <div className="form-check form-switch me-4 mb-0">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="globalAdminSwitch"
                                                            checked={isGlobalAdmin}
                                                            disabled={!user.isGlobalAdmin}
                                                            // onChange={(e) => {
                                                            //     const checked = e.target.checked;
                                                            //     setIsGlobalAdmin(checked);
                                                            //     if (checked) {
                                                            //         setBulkRole(1);
                                                            //     } else {
                                                            //         setBulkRole(0);
                                                            //     }
                                                            // }}

                                                            onChange={(e) => {

                                                                const checked = e.target.checked;

                                                                setIsGlobalAdmin(checked);

                                                                if (checked) {

                                                                    setBulkRole(1);

                                                                    setFolderRoles(

                                                                        folderList.map(folder => ({
                                                                            folderId: folder.folderIdentifier,
                                                                            role: userRole.GlobalAdmin
                                                                        }))

                                                                    );

                                                                }
                                                                else {

                                                                    setBulkRole(0);

                                                                    setFolderRoles([]);

                                                                }

                                                            }}
                                                        />

                                                        <label
                                                            className="form-check-label ms-2"
                                                            htmlFor="globalAdminSwitch"
                                                        >
                                                            Global Admin
                                                        </label>
                                                    </div>

                                                    {/* Divider */}
                                                    <div className="vr me-4"></div>

                                                    {/* Bulk Role */}
                                                    <div className="d-flex align-items-center">

                                                        <label className="me-2 mb-0 fw-semibold">
                                                            Bulk Role
                                                        </label>

                                                        <select
                                                            className="form-select"
                                                            disabled={isGlobalAdmin}
                                                            style={{ width: "220px" }}
                                                            value={bulkRole}
                                                            onChange={(e) =>
                                                                handleBulkRoleChange(Number(e.target.value))
                                                            }
                                                        >
                                                            <option value={0}>
                                                                Select Role
                                                            </option>

                                                            {getHighestCreatableRoles().map(role => (
                                                                <option
                                                                    key={role.id}
                                                                    value={role.id}
                                                                >
                                                                    {role.label}
                                                                </option>
                                                            ))}
                                                        </select>

                                                    </div>

                                                </div>

                                                {/* Right Side */}
                                                <div>

                                                    <button
                                                        type="button"
                                                        disabled={isGlobalAdmin}
                                                        className="btn btn-outline-secondary btn-sm me-2"
                                                        onClick={handleSelectAll}
                                                    >
                                                        Select All
                                                    </button>

                                                    <button
                                                        type="button"
                                                        disabled={isGlobalAdmin}
                                                        className="btn btn-outline-secondary btn-sm"
                                                        onClick={handleDeselectAll}
                                                    >
                                                        Deselect All
                                                    </button>

                                                </div>

                                            </div>


                                            {/* <div className="form-check form-switch mt-3">

                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="globalAdminSwitch"
                                                    checked={isGlobalAdmin}
                                                    onChange={(e) => {

                                                        const checked = e.target.checked;
                                                        setIsGlobalAdmin(checked);
                                                        if (checked) {
                                                            setBulkRole(1);
                                                        }
                                                        else {
                                                            setBulkRole(0);   // or 2 if BusinessUnitAdmin should be the default
                                                        }

                                                    }}
                                                />

                                                <label
                                                    className="form-check-label"
                                                    htmlFor="globalAdminSwitch"
                                                >
                                                    Global Admin
                                                </label>

                                            </div>
                                            <div className="mb-2">
                                                <label for="dropdownMenuButton1" class="form-label">Bulk Role</label>

                                                <select
                                                    className="form-control form-select"
                                                    value={bulkRole}
                                                    onChange={(e) => handleBulkRoleChange(Number(e.target.value))}
                                                >
                                                    <option value={0}>Select Bulk Role</option>

                                                    {visibleRoles.map(role => (
                                                        <option
                                                            key={role.id}
                                                            value={role.id}
                                                        >
                                                            {role.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div> */}





                                            {/* <div className="d-flex justify-content-end mb-3">

                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm me-2"
                                                    onClick={handleSelectAll}

                                                >
                                                    Select All
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={handleDeselectAll}
                                                >
                                                    Deselect All
                                                </button>

                                            </div> */}
                                            <div className="folder-header row fw-bold border-bottom pb-2 mb-2" style={{ background: '#f4f5f7', borderTop: '1px solid #d8d8d8', borderBottom: '1px solid #d8d8d8', padding: '10px 0', marginBottom: '0' }}>

                                                <div className="col-5">
                                                    Folder Name
                                                </div>

                                                <div className="col-3">
                                                    Assigned Role
                                                </div>

                                                <div className="col-4">
                                                    Access Summary
                                                </div>

                                            </div>

                                            {/* <div className='all-check'>
                                                <input type="checkbox" id='all' onChange={handleSelectAllFolders} checked={CheckAll() ? false : true} disabled={roleSelection === 1} /> <label for="all">Select All Folders</label>
                                            </div> */}
                                            {folderList.map((folder) => {


                                                const currentFolderRole = folderRoles.find(x => x.folderId === folder.folderIdentifier);

                                                console.log("========== Folder Render ==========");
                                                console.log("Folder Name:", folder.name);
                                                console.log("Folder Identifier:", folder.folderIdentifier);
                                                console.log("FolderRoles State:", folderRoles);
                                                console.log("Matched Folder Role:", currentFolderRole);
                                                console.log("Dropdown Value:", currentFolderRole?.role ?? 0);

                                                return (
                                                    // <div className='single-check'>
                                                    //     <input type="checkbox" id={folder.folderIdentifier} checked={folderRoles.some(x => x.folderId === folder.folderIdentifier)} onChange={() => handleFolderSelection(folder.folderIdentifier)} /> <label for={folder.name} ><img src="../Assets/folder-icon.svg" alt='User' /> {folder.name}</label>
                                                    // </div>

                                                    //<div className='single-check'>
                                                    //     <input type="checkbox" id={folder.folderIdentifier} checked={folderRoles.some(x => x.folderId === folder.folderIdentifier)} onChange={() => handleFolderSelection(folder.folderIdentifier)} /> <label for={folder.name} ><img src="../Assets/folder-icon.svg" alt='User' /> {folder.name}</label>

                                                    //     {folderRoles.some(x => x.folderId === folder.folderIdentifier) && (
                                                    //         <select
                                                    //     className="form-select"
                                                    //     value={
                                                    //         folderRoles.find(x => x.folderId === folder.folderIdentifier)?.role ?? 0
                                                    //     }
                                                    //     onChange={(e) =>
                                                    //         handleFolderRoleChange(
                                                    //             folder.folderIdentifier,
                                                    //             Number(e.target.value)
                                                    //         )
                                                    //     }
                                                    // >
                                                    //     <option value={0}>None</option>

                                                    //     {visibleRoles.map(role => (
                                                    //         <option
                                                    //             key={role.id}
                                                    //             value={role.id}
                                                    //         >
                                                    //             {role.label}
                                                    //         </option>
                                                    //     ))}
                                                    // </select>
                                                    //     )}
                                                    //</div>
                                                    <div className="row align-items-center single-check border-bottom py-2">

                                                        <div className="col-5 d-flex align-items-center">

                                                            <input
                                                                type="checkbox" disabled={isGlobalAdmin}
                                                                id={folder.folderIdentifier}
                                                                checked={folderRoles.some(x => x.folderId === folder.folderIdentifier)}
                                                                onChange={() => handleFolderSelection(folder.folderIdentifier)}
                                                            />

                                                            <label htmlFor={folder.folderIdentifier} className="ms-2 fw-semibold">
                                                                <img src="../Assets/folder-icon.svg" alt="folder" />
                                                                {" "}
                                                                {folder.name}
                                                            </label>

                                                        </div>

                                                        <div className="col-3">

                                                            {(

                                                                <select
                                                                    className="form-select"

                                                                    //disabled={!folderRoles.some(x => x.folderId === folder.folderIdentifier)}
                                                                    disabled={
                                                                        isGlobalAdmin ||
                                                                        !folderRoles.some(
                                                                            x => x.folderId === folder.folderIdentifier
                                                                        )
                                                                    }
                                                                    value={
                                                                        folderRoles.find(x => x.folderId === folder.folderIdentifier)?.role ?? 0
                                                                    }

                                                                    onChange={(e) =>
                                                                        handleFolderRoleChange(
                                                                            folder.folderIdentifier,
                                                                            Number(e.target.value)
                                                                        )
                                                                    }
                                                                >

                                                                    <option value={0}>Select Role</option>

                                                                    {getVisibleRoles(folder.folderIdentifier).map(role => (

                                                                        <option
                                                                            key={role.id}
                                                                            value={role.id}
                                                                        >
                                                                            {role.label}
                                                                        </option>

                                                                    ))}

                                                                </select>

                                                            )}

                                                        </div>
                                                        <div className="col-4">
                                                            <div className="small">

                                                                {
                                                                    getRoleSummary(
                                                                        folderRoles.find(
                                                                            x => x.folderId === folder.folderIdentifier
                                                                        )?.role
                                                                    )
                                                                }

                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                        </div>
                                    </div>
                                    {folderRequiredError && (
                                        <p className="error-message">* Please select at least one folder</p>
                                    )}

                                </div>

                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleclose}>
                                Cancel
                            </button>
                            <button disabled={subBtnDisabled} className='btn btn-primary' type='submit'>Submit</button>
                        </div>
                    </form>
                    <div className={`toast-message ${showToast ? 'active' : ''}`}>
                        User Created Successfully. <span className='close-btn' >X</span>
                    </div>
                </div>
            </div>
        </>
    )
}
